import '@kingshott/iodine';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'
import lunr from 'lunr';
import Choices from 'choices.js';
import axios from 'axios';
import smoothscroll from 'smoothscroll-polyfill';


// Utilities
import { fadeIn, fadeOut } from './modules/utilities';

window.fadeOut = fadeOut;
window.fadeIn = fadeIn;
window.axios = axios;


// Form
const choicesNativeElement = document.querySelector('.js-choices');
if (choicesNativeElement){
    const labelId = `${choicesNativeElement.id}__label`
    const inputId = `${choicesNativeElement.id}__combobox`;
    const listId = `${choicesNativeElement.id}__list`;
	const choices = new Choices(choicesNativeElement, {
		allowHTML: false,
		removeItemButton: true,
        shouldSort: false,
	});

    // Choices.js is inaccessible and misunderstands the point of ARIA, labels, and placeholders
    // - The following is a workaround until we switch to a better component
    choices.input.element.removeAttribute('aria-label');
    choices.input.element.setAttribute('id', inputId);
    choices.input.element.setAttribute('aria-haspopup', 'listbox');
    choices.input.element.setAttribute('aria-expanded', false);
    choices.input.element.setAttribute('aria-controls', listId);
    choices.input.element.setAttribute('aria-describedby',"adventures_intructions");
    choices.choiceList.element.setAttribute('id', listId);
    choices.choiceList.element.setAttribute('aria-labelledby', labelId);

    choicesNativeElement.addEventListener('showDropdown', () => {
        choices.input.element.setAttribute('aria-expanded', true);
    });
    choicesNativeElement.addEventListener('hideDropdown', () => {
        choices.input.element.setAttribute('aria-expanded', false);
    });
}

Iodine.rule('checked', (value) => value);
Iodine.setErrorMessage('checked', "[FIELD] must be checked");

function form() {
	return {
		inputElements: [],
		success: false,
		error: false,
        submitting: false,
        formPartial: null,
        errorMessages: {},
		init() {
			this.inputElements = [...this.$el.querySelectorAll("[data-rules]")];
            this.inputElements.forEach(element => (
                element.addEventListener("invalid", this.updateAllErrorMessages.bind(this))
            ));
	  	},
        updateErrorMessage: function (element) {
            const value = element.type === "checkbox" ? element.checked : element.value;
            const {error} = Iodine.assert(value, JSON.parse(element.dataset.rules));
            this.errorMessages[element.name] = error;
		},
		updateAllErrorMessages: function () {
			this.inputElements.forEach((element) => this.updateErrorMessage(element));
		},
		reserveFormExtras: function() {
			const adventures = document.getElementById('adventures');
			let selected = [];
			if(adventures){
				for (var option of document.getElementById('adventures').options) {
					selected.push(option.value);
				}
				const selectedAdventures = selected.join('; ');

				return {
					adventures: selectedAdventures
				}
			} else {
				return false;
			}
		},
        urlencode(string) {
            return window.encodeURIComponent(string).replace(/%20/g, '+');
        },
		submit: function(event) {
            event.preventDefault();

			let self = this;
			let action = this.$el.getAttribute('action');
			let data = this.formPartial === 'reserve-a-seat'
                ? Object.fromEntries(new FormData(this.$el))
                : [...new FormData(this.$el)].reduce((accumulator, [key, value]) => {
                    if (accumulator) {
                        accumulator += '&';
                    }

                    accumulator += `${this.urlencode(key)}=${this.urlencode(value)}`;
                    return accumulator;
                }, '');

            if (this.formPartial === 'reserve-a-seat') {
                // Reserve a Seat form one offs
                const extras = this.reserveFormExtras(data);
                if (extras){
                    data.adventures = extras.adventures;
                }
            } else if (this.formPartial === 'media-inquiry') {
                // Media Inquiry one offs
                const deadline = {
                    month: document.getElementById('month').value,
                    day: document.getElementById('day').value,
                    year: document.getElementById('year').value,
                };
                const hasDeadline = deadline.month || deadline.day || deadline.year;
                data += `&deadline=${this.urlencode(hasDeadline ? [
                    deadline.month,
                    deadline.day,
                    deadline.year,
                ].map(value => value || '[Not Specified]').join('-') : '[Not Specified]')}`;
            }

            // Send request as long as one is not pending
            if (!this.submitting) {
                this.submitting = true;

                // Axios it to the form action
                axios.post(
                    action,
                    data,
                    {
                        headers: {
                            "Content-Type": this.formPartial === 'reserve-a-seat' ? 'application/json' : 'application/x-www-form-urlencoded',
                        },
                    },
                )
                  .then(function (response) {
                    console.log(response);
                    self.error = false;
                    self.success = true;
                    self.submitting = false;
                  })
                  .catch(function (er) {
                    console.log(er);
                    self.success = false;
                    self.error = true;
                    self.submitting = false;
                });
            }
		},
		change: function (event) {
			// For the inputs we're validating, check to see if the new value is valid
			if (this.inputElements.includes(event.target)) {
                this.updateErrorMessage(event.target);
			}
		}
	};
}


// Init Alpine
Alpine.plugin(intersect)
Alpine.plugin(focus)
Alpine.data("form", form);
window.Alpine = Alpine
Alpine.start()


// init others
window.lunr = lunr;
smoothscroll.polyfill();


// Show/hide + bg color nav on scroll down and up
let prevScrollpos = window.pageYOffset;
let header = document.getElementById("header");

// Handle Hero Animations
var throttleTimer;
const components = document.querySelectorAll(".component");

const throttle = (callback, time) => {
	if (throttleTimer) return;

	throttleTimer = true;
	setTimeout(() => {
		callback();
		throttleTimer = false;
	}, time);
}

const elementInView = (el, percentageScroll = 100) => {
	const elementTop = el.getBoundingClientRect().top;
	return (
		elementTop <=
		((window.innerHeight || document.documentElement.clientHeight) * percentageScroll)
	);
};

const displayAnimatedElements = (element) => {
	element.classList.add("scrolled");
	let children = element.querySelectorAll('.animate');
	if(children.length > 0 ){
		children.forEach((el) => {
			el.classList.add('animated'); // Classes are from animate.css
		});
	}
};

const fadeInBackground = (element) => {
	element.classList.add("scrolled");
	let background = element.querySelector('.background-video-image');
	if(background){
		background.classList.add('fade-in'); // Classes are from animate.css
	}
};

const handleScrollAnimation = () => {
	components.forEach((el) => {

		// Handle fading in the background
		if(elementInView(el, 0.9)){
			fadeInBackground(el);
		}

		// Handle fading in the child items
		if (elementInView(el, .55)) {
			displayAnimatedElements(el);
		}
	})
}

const showAltLogo = (distance) => {

	if(distance > 76 && logo){
		header.classList.add('header--hidden');
	} else {
		header.classList.remove('header--hidden');
	}
}

window.addEventListener('load', (event) => {
	handleScrollAnimation();
});

let landingScrollWrap = document.getElementById('landing-page-scroll-wrap');
if(landingScrollWrap){
	landingScrollWrap.addEventListener("scroll", (e) => {
		throttle(() => {
			showAltLogo(e.target.scrollTop);
			handleScrollAnimation();
		}, 250, [e]);
	});
}

window.addEventListener('scroll', () => {
	throttle(() => {
		handleScrollAnimation();
	}, 250);
});

handleScrollAnimation(); // This is is here as a  test to see if it will help us load the content for times when people aren't getting it

const accessibilityFont=(font)=>{
	let body=document.querySelector('body');
	let options=document.querySelectorAll('.links-list-cont__select-wrap__select__option');
	options.forEach((i)=>{
		 body.classList.remove(`${i.value}`);
	})
	if(font!='none'){
		body.classList.add(`${font}`);
	}
}
if (document.getElementById('accessibility-font')){
	document.getElementById('accessibility-font').addEventListener('change',(e)=>{
		let font=e.target.value;
		localStorage.setItem('fontTakeOver', font);
		accessibilityFont(font);
	})
}
// Dom Loaded
document.addEventListener('DOMContentLoaded', function () {

	// Takeover close
	let closeButtons = document.querySelectorAll('.close-takeover');
	closeButtons.forEach(function(close){
		close.addEventListener('click', function(){
			let openTakeover = document.querySelector('.takeover.active');
			openTakeover.classList.remove('active');
			document.querySelector('body').classList.remove('takeover-enabled');
		})
	})
	// Accessibility  Font
	let font=localStorage.getItem('fontTakeOver');
	if (font && document.getElementById('accessibility-font')){
		document.getElementById('accessibility-font').value=font;
		accessibilityFont(font);
	}

}, false);


